<template>
    <button class="link--btn" :class="classList">
        <router-link :to="link">
            <div class="link--btn__inner">
                <span class="link--btn__in">{{ text }}</span>
            </div>
        </router-link>
    </button>
</template>

<script>
export default {
  name: 'app-button',

  props: {
      text: {
          type: String,
          required: true
      },
      link: {
          type: [Object, String],
          required: true
      },
      spaces: {
          type: String,
          default: 'small'
      }
  },

  computed: {
    classList()
    {
        return { 
            'link--btn--medium': this.spaces === 'medium',
            'link--btn--space-right': this.spaces === 'right',
        }
    }
  },
  data() {
    return {
        
    }
  },
}
</script>

<style lang="stylus">

</style>